import type { Feature, Geometry } from 'geojson';
import { SourceBase } from './SourceBase';
import type { SourceOptions } from './Sources.types';

export class StaticSource extends SourceBase {
    constructor(data: Feature<Geometry, { [name: string]: unknown }>[], options?: SourceOptions) {
        super({ ...options, id: 'static-source' });

        this._data = data;
    }
    hasDetailsLoader(): boolean {
        return false;
    }
    getAjaxPromise(): Promise<Feature<Geometry, { [name: string]: unknown }>[]> {
        return Promise.resolve(this._data);
    }
}
